import React, { useEffect } from 'react';
import { Box, Paper, CircularProgress } from '@mui/material';
// Backdrop 
import { useState, Downgraded, } from '@hookstate/core';
// import Title from '../../sharedcomponents/title/title';
import DataList from './dataList/dataList';
import { FULL_PERMISSION } from '../../constants/Constant';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import { useEventState } from '../../stores/eventStore';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import UserListDialog from './userListDialog';
import ViewNotification from './viewNotification';
// import CircularProgressWithLabel  from '../../sharedcomponents/crcularProgressWithLabel'
const SentNotificationList = () => { 
    const loading = useState(false);
    const [modPermission, setModPermission] = React.useState(null);
    const eventState = useEventState();
    const allData = useState([]);
    const eventData = useState(null);
    const userData = useState(null)
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const isView = useState(false);
    const currentNotification = useState({});
    const overallParticipants = useState([]);
    const filteredParticipants = useState([]);
    const openAddParticipantDialog = useState(false);
    const openNotification = useState(false);
    const editNotificationInfo = useState()

    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState && eventState.eventDetail.get()) {
            if (Helper.isAdminUser(userInfo)) {
                setModPermission(FULL_PERMISSION);
            } else if (userInfo.roles && Helper.isEventAdmin(userInfo)) {
                // const permissions = eventState.permissions
                //     .attach(Downgraded)
                //     .get();
                // if (permissions && permissions.length > 0) {
                //     setModPermission(
                //         Helper.getModuleAccessPermission(permissions, 'HOTEL')
                //     );
                // }
                setModPermission(FULL_PERMISSION);
            }
        }

    }, [eventState]);
    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        ) {
            eventData.set(eventInfo);
            userData.set(userInfo)
        }

        ApiHelper.get(APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(eventData.get().eventID))
            .then(res => {
                let participantData = [];
                res.data.rows.map((item) => {
                    participantData.push({ ...item, selected: false })

                })
                overallParticipants.set(participantData);

            })

    }, [])

    useEffect(() => {
        getNotification();
    }, [])
    const handleClose = () =>
    {
        openNotification.set(false);
        editNotificationInfo.set(null)
    }
    const getNotification = () => {
        loading.set(true);
        let participantList = [];
        let activityData = []
        ApiHelper.get(APIURLConstants.GET_NOTIFICATION(eventData.get().eventID)).then(res => {  
            if (res.data.length > 0) { 
                let data = res.data;
                const copy = data.slice();
                const sorter = (a, b) => {
                   return a['index'] - b['index'];
                };
                copy.sort(sorter);
                if (copy.length > 0) {

                    data.map((item) => {
                        if (item.notificationStatus === 2) {

                            item.participants.map((user) => {
                                if (
                                    participantList.indexOf(user.participants) == -1
                                ) {
                                    participantList.push(user.participants);
                                }
                            })

                            activityData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'Action',
                                        key: 'Notification',
                                        Notification: 'Notification',
                                        width: '0.05',
                                        inColumn: true,
                                        alignCenter: true,
                                        isOpened: item.notificationStatus
                                    },
                                    {
                                        label: 'Name',
                                        key: 'message',
                                        message: item.notificationText,
                                        showLabel: false,
                                        width: '0.50',
                                        inColumn: true,
                                        showDetails: true,
                                        createdDate:
                                            Helper.FormatDate(
                                                item.createdDate
                                            ) +
                                            ' @ ' +
                                            Helper.FormatTime(
                                                item.createdDate
                                            ),
                                        createdBy: item.createdByName
                                    },
                                    {
                                        label: 'Status',
                                        key: 'status',
                                        status:
                                            item.notificationStatus == 2 ? 'Sent ' +
                                                ' On ' +
                                                Helper.FormatDate(
                                                    item.sendDate
                                                ) +
                                                ' @ ' +
                                                Helper.FormatTime(
                                                    item.sendDate
                                                ) : 'Unsent',
                                        width: '0.35',
                                        inColumn: true,
                                        isSent: true
                                    },
                                    {
                                        label: 'Action',
                                        key: 'participants',
                                        participants: 'Participants',
                                        count: item.participants != null ? item.participants.length : 0,
                                        width: '0.05',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'viewnotification',
                                        viewnotification: 'Notificaiton',
                                        // count: item.participants != null ? item.participants.length : 0,
                                        width: '0.05',
                                        inColumn: true,
                                    },
                                ],
                                selected: false,
                                emailSelected: item.type,
                                includeConnectionSelected: item.includeConnections
                            });
                        }
                    })
                }
                else {
                    activityData = [];
                }
            }
            loading.set(false)
        }).catch(err => {
            console.log(err);
            loading.set(false)
        })
        // loading.set(false);
        allData.set(activityData)


    }






    const handleViewParticipants = (notification) => {
        currentNotification.set(notification)
        isView.set(true)
        ApiHelper.get(APIURLConstants.GET_NOTIFICATION_PARTICIPANTS(notification.actualData.notificationID))
            .then(participants => {
                let ids = participants.data.map(x => x.userID);
                let allParticipants = overallParticipants.attach(Downgraded).get()
                let userList = allParticipants.filter(x => ids.includes(x.userID))
                filteredParticipants.set(userList)
                openAddParticipantDialog.set(true);
            }).catch(err => {
                console.log(err);
                setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
            })
    }

    const handleCloseAddParticipant = () => {
        openAddParticipantDialog.set(false);
        isView.set(false);
    }
    const deleteParticipants = (selectedUsers) => {
        if (selectedUsers.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
        } else {
            const userInfo = Helper.getStorage('userInfo');
            let notification = currentNotification.attach(Downgraded).get();
            let obj = { eventID: eventData.get().eventID, notificationID: notification.actualData.notificationID, modifiedBy: userInfo.userID, Ids: selectedUsers }
            deleteNotificationParticipants(obj)
                .then(res => {
                    if (res) {
                        setSnackBarProps({ openSnack: true, variant: 'success', message: 'Participants deleted successfully.' });
                        getNotification();
                        openAddParticipantDialog.set(false);
                        isView.set(false);
                    } else {

                        setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                    }

                })
                .catch(err => {
                    console.log(err);

                    setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                })
        }
    }

    function deleteNotificationParticipants(obj) {
        return ApiHelper.post(APIURLConstants.DELETE_NOTIFICATION_PARTICIPANTS, obj)
            .then(result => {
                return result.data;
            })
            .catch(err => {
                console.log(err);
            });
    }

    const handleViewNotification = (item) => {
        // console.log(item);
        editNotificationInfo.set(item.actualData)
        openNotification.set(true);
    }
    return (
        <Box sx={{ width: '100%' }}>
            {loading.get() ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                        marginTop: '15%'
                    }}>
                    <CircularProgress />

                </Box>
            ) : (
                <Box>

                    <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none',backgroundColor:'unset' }}>
                        <DataList
                            showSearch={true}
                            data={allData.attach(Downgraded).get()}
                            title={''}
                            hideAdd={true}
                            hideDelete={true}
                            modPermission={modPermission}
                            searchLabel={'Search'}
                            handleViewParticipants={handleViewParticipants}
                            handleViewNotification={handleViewNotification}
                        />
                    </Paper>

                </Box>
            )
            }
            {openAddParticipantDialog.get() && (
                <UserListDialog
                    title={"VIEW PARTICIPANTS"}
                    open={openAddParticipantDialog.get()}
                    deleteParticipants={deleteParticipants}
                    handleClose={handleCloseAddParticipant}
                    users={filteredParticipants.attach(Downgraded).get()}
                    isView={isView.get()}
                    sentInvitationList={true}
                    selectAllCheckBox={true}
                />
            )}
            {openNotification.get() &&
                <ViewNotification
                    notificationInfo={editNotificationInfo
                        .attach(Downgraded)
                        .get()}
                    title="View Notification"
                    open={openNotification.get()}
                    handleClose={handleClose}
                    getNotification={getNotification}
                    setSnackBarProps={setSnackBarProps}
                    readOnly={true}
                />}



            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {/* <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openBackdrop}
            >
                {/* <CircularProgress color="inherit" /> */}
            {/*  <CircularProgressWithLabel value={progress} />;
            </Backdrop> */}
        </Box>

    )
}

export default SentNotificationList